import React from 'react';

import SocialFacebook from '../../reusable-components/icons/social/SocialFacebook';
import SocialInstagram from '../../reusable-components/icons/social/SocialInstagram';
import SocialYoutube from '../../reusable-components/icons/social/SocialYoutube';
import './social.less';

const Social = () => {
  return (
    <div className="socialHolder">
      <a
        href={window.headerData.links.youtube}
        target="_blank"
        rel="noopener noreferrer"
      >
        <SocialYoutube />
      </a>
      <a
        href={window.headerData.links.instagram}
        target="_blank"
        rel="noopener noreferrer"
      >
        <SocialInstagram />
      </a>
      <a
        href={window.headerData.links.facebook}
        target="_blank"
        rel="noopener noreferrer"
      >
        <SocialFacebook />
      </a>
    </div>
  );
};

export default Social;
